import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, CODE_SPACE, VALUE_ENTER, WizDateUtils, WIZ_UPLOAD_ACCEPT_FORMAT, WIZ_PHYSIC_POSITION, CONFIRMATION_MODE, CONFIRMATION_RESULT, WizFileUtils } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  WizButton,
  WizCheckbox,
  WizDateField,
  WizHgroup,
  WizImage,
  WizLabel,
  WizNumericInput,
  WizRoot,
  WizTextarea,
  WizTextInput,
  WizValidationContainerDirective,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizGroup,
  WizIcon,
  UploadParameter,
  ImageUploadParameter,
  WizEventManager, WizEvent,
  WizPopUp,
  WizVgroup,
  ConfirmationResultObj,
  IWIZComponent,
  PopUpManager,
  WizDatasource,
  WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { first, Observable, of } from 'rxjs';
import { BaselineEngine, FeiKeyDef, FIELD_KIND, KEY_KIND, MathUtils, MeasureVO, WizConstants } from '@wizeoo/akm-compute-lib';
import { Attachment, Measure, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { AngularEditorComponent, AngularEditorConfig } from '@wfpena/angular-wysiwyg';
import { IForm } from '../../../../manager/widgets/i-form';
import { ALK_EVENT_TYPE, WIDGET_GLOBAL_KIND } from '../../../../model/enums';
import { ViewData } from '../../../../model/view.data';
import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { FreeDataVO } from '../../../../vo/core/freedata.vo';
import { ConnectVO } from '../../../../vo/core/connect.vo';
import { FreedataArgsVO } from '../../../../vo/core/freedataargs.vo';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { StyleEngine } from '../../../../manager/workingdata/style.engine';
import { MediaReference } from '../../../../command/core/attachment/attachment.service';
import { AttachmentService } from '../../../../command/core/attachment/attachment.service';
import { Model } from '../../../../model/model';
import { IFreedataWidget, PivotCellEditPopData } from '../../../../manager/widgets/i-widget';
import { FormDropExtendedRenderer } from '../../form/drops/form-drop-extended.renderer';
import { ColorPickerPop } from '../../../colorpicker/color-picker.pop';
import { getDefaultWidgetConfigurationItemObj } from '../../../../manager/widgets/widget.engine';
import { PopUtils } from '../../../../framework/components/pop/pop-utils';
import { FormatVO } from '../../../../vo/workingdata/format.vo';
import { SwapPop } from './swap.pop';
import { ThumbData } from './thumb.renderer';
import { zoomPopParams } from './zoom.pop';

/** un champ complémentaire sur un FD (la structure de ce champ) */
export type ArgEditorData = { 
  model: Model,
  arg: FreedataArgsVO, 
  fdv: FreedataValueVO, 
  context?: GridsterWidgetItem,
  fdvView?: boolean,
  provider?: WizDatasource<any>
 };

/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'args-renderer',
  templateUrl: './args.renderer.html',
})
export class ArgsRenderer implements AfterViewInit, IWizItemRenderer<WidgetConfigurationItemObj, ArgEditorData> {
   
  
  @ViewChild('argContainer') argContainer: WizHgroup; // groupe principal
  /** Zone de validation des champs de saisie */
  @ViewChild('argContainer', { read: WizValidationContainerDirective, static: false }) validationContainer: WizValidationContainerDirective;

  @ViewChild('ddext', { read: FormDropExtendedRenderer }) ddext: FormDropExtendedRenderer;
  
  // @ViewChild('dd', { read: WizDropdown }) dd: WizDropdown;
  @ViewChild('ni', { read: WizNumericInput, static: false }) ni: WizNumericInput;
  @ViewChild('ti', { read: WizTextInput, static: false }) ti: WizTextInput;
  @ViewChild('tiObject', { read: WizTextInput, static: false }) tiObject: WizTextInput;
  @ViewChild('ta', { read: WizTextarea, static: false }) ta: WizTextarea;
  @ViewChild('da', { read: WizDateField, static: false }) da: WizDateField;
  @ViewChild('cb', { read: WizCheckbox, static: false }) cb: WizCheckbox;

  @ViewChild('imgGp', { read: WizHgroup, static: false }) imgGp: WizHgroup; // image du FDV
    @ViewChild('imgLbl', { read: WizLabel, static: false }) imgLbl: WizLabel;
    @ViewChild('img', { read: WizImage, static: false }) img: WizImage;
  
  @ViewChild('bt', { read: WizButton, static: false }) bt: WizButton; // fonction connect

  @ViewChild('dropGrp', { read: WizGroup, static: false }) dropGrp: WizGroup; // zone de drop de fichier
  @ViewChild('icoAddFile', { read: WizIcon, static: false }) icoAddFile: WizIcon; // ajout de fichier
  @ViewChild('icoDelFile', { read: WizIcon, static: false }) icoDelFile: WizIcon; // suppression du lien de fichier

  
  @ViewChild('linkGp', { read: WizHgroup, static: false }) linkGp: WizHgroup; // rendu hyperlink du FDV

  @ViewChild('freeGrp', { read: WizHgroup, static: false }) freeGrp: WizHgroup; // rendu html libre
  @ViewChild('ae') ae: AngularEditorComponent; // free html compo
   
  @ViewChild('freeImgGrp', { read: WizHgroup, static: false }) freeImgGrp: WizHgroup; // groupe image libre
    @ViewChild('freeImg') freeImg: WizImage; // image libre

  @ViewChild('cellBlockBack') cellBlockBack: ElementRef; // zone de dessin de la couleur de background
  @ViewChild('icoLoadFile') icoLoadFile: WizIcon; // icone téléchargement, toujours dispo

  @ViewChild('workflowGroup', { read: WizVgroup, static: false }) workflowGroup: WizVgroup; // rendu hyperlink du FDV
  
  @ViewChild('icoList') icoList: any; // icône pour ouverture de la liste de valeurs
  @ViewChild('icoList') icoThreshold: any; // icône pour ouverture de la liste des seuils
  
  constructor(public elementRef: ElementRef, public cdref: ChangeDetectorRef) {}

  owner: null;
  @Input() public data: ArgEditorData;

  public get injectClass(): string {
    let myclass: string = 'voidme';
    if(!!this.context?.sty) {
      myclass = this.context?.sty;
    }
    return myclass;
  }

  /** accesseur sur le field du WidgetItem, casté */
  public get field(): PivotField {
    const field: PivotField =  this.data?.context?.field as PivotField;
    return field;
  }

  /**
   * contexte. Attention, non disponible dans la vue Freedata
   */
  public get context(): WidgetConfigurationItemObj {
    return  this.field?.contextItem; //  this.data?.context?.source;
  }

  /** accesseur sur le freedataValue */
  public get sourceFDV(): FreedataValueVO {
    return this.data?.fdv;
  }

  /** accesseur sur le freedataArg */
  public get sourceArg(): FreedataArgsVO {
    return this.data?.arg;
  }

  /** accesseur sur le widget, casté */
  public get widget(): IFreedataWidget {
    return this.field?.widget ? this.field.widget as IFreedataWidget : null;
  }

  public get model(): Model {
    return this.data.model;
  }

  private datakind: string = null; // FIELD_KIND; // le format réel (peut être altéré par les formules)
  private rawValue: string = null; // valeur brute (en cours de traitement)
  public formatedValue: any = null; // la valeur formatée pour le rendu dans les composants 
  public ffoValue: any = null; // la valeur formatée pour le rendu des drops
  
  private subArg: FreedataArgsVO = null; // en cas de rendu sur un autre champ du sous-FD, prise de l'arg
  private subFDV: FreedataValueVO = null; // éventuel override pour un subField

  wizdisabled: boolean = false;

  /** accesseur sur le freedataValue (soit l'origine, soit celui du subField) */
  public get realFDV(): FreedataValueVO {
    return this.subFDV ? this.subFDV : this.sourceFDV;
  }

  /** accesseur sur le freedataValue (soit l'origine, soit celui du subField) */
  public get realArg(): FreedataArgsVO {
    return this.subArg ? this.subArg : this.sourceArg;
  }


  private otherMap: Map<string, FreedataValueVO> = null; // mémorisation de la map pour contrôles de cohérence

  /* ##############################################################################
                  paramètres d'affichage
  ############################################################################## */

    //##### les activateurs de ngIf ######
    // usedd = false; // drop (champ FD)...
    useddext = false; // drop (champ FD)...
    useni = false;
    decimal = 2;
    wizmin = null;
    wizmax = null;

    useti = false;
    public forceCaps: string = 'voidme'; // forcer l'upperCase en cas de shortCode, rien par défaut
    public forceRestrict = null; // restriction sur saisie de code / shortCode
    
    usetiObject = false; // rendu inerte pour les sous-propriétés des sous-FD

    useta = false;
    useda = false;
    usecb = false;
    useimgGp = false;
    usemedia = false;
    usecolor = false;
    
    uselistGP = false; // champs liste de valeurs
    usethresholdGP = false; // champ seuil

    uselinkGp = false; // pas de link par défaut...
    public linkUrl: string = ''; // cas d'un rendu link, label|url
    public linkLabel: string = ''; // cas d'un rendu link, label|url

    usebt = false; // fonction connect
    public cnx: ConnectVO = null; // fonction connect du bouton

    useDropGrp = false; // zone de drop de fichier

    usefreeGrp = false; // gestion rendu libre
    readyfreeGrp = false; // prêt pour l'affichage, évite la toolbar
  
    
    usefreeImgGrp = false; // image libre
    public imgSrcObs: Observable<string> = of(null);
    public imgBlobid: string = null;
    public mediaReference: MediaReference = null;

    useworkflow = false; // rendu workflow
      public workImage: Observable<string> = of(null); // image liée
      public workImageBlob: string = null;
      public workIcon: string = null; // l'icone du statut si utilisée
      public workflowLabel: string = null; // le libellé du workflow
      public workFile:  MediaReference = null; // pièce jointe

    usefreeZone = false; // rendu container
      public freezoneHidden: boolean = false;
    
    public get freezonelabel(): string {
      let res: string;
      if(this.freezoneHidden) {
        res = WizTranslationManager.getInstance().translateKey('$.common.open.$');
      } else {
        res = WizTranslationManager.getInstance().translateKey('$.common.hide.$');
      }
      return res;
    }
    public get freezoneicon(): string {
      // let res: string = 'reduce';
      let res: string;
      if(this.freezoneHidden) {
        res = 'creation';
      } else {
        res = 'reduce';
      }
      // console.log("TODO selon value (reduce / creation)");
      return res;
    }

  /** configuration de l'editeur html */
  public editorConfig:AngularEditorConfig = {
      width: '100%',
      height: '100%',
      editable: false,
      enableToolbar: false,
      showToolbar: false,
      placeholder: null,
      spellcheck: false,
      sanitize: false
  }

  /* ##############################################################################
                  accesseurs dynamiques pour le rendu visuel
  ############################################################################## */

  /** rendu label custom ou label par défaut */
  public get alternateLabel(): string {
    let result: string = this.data?.arg?.trsLabel;
    if(!!this.field?.contextItem?.lbl) {
      result = this.field.contextItem.lbl;
    }
    return result;
  }

  /** affichage ou pas du libellé */
  public get showLabel() :boolean {
    // console.log('argRenderer showLabel', this._data.context?.showLabel);
    return !this.data.context || this.field?.contextItem?.slbl;
  }

  /** présence d'une image, pour affichage de la poubelle */
  public get hasImage(): boolean {
    const valueStr: string = !!this.data.arg ? this.data?.fdv?.argsObjVO[this.data.arg.code] : null;
    return !!valueStr;
  }

  /** readonly sur les images, pas de poubelle */
  public get readOnly():boolean {
    return this.argContainer?.wizDisabled;
  }

  /** on utilise le lien vers un fichier, et il existe */
  public get dropFull():boolean {
    // console.log('dropFull', this.datakind, this. formatedValue);
    return this.datakind === FIELD_KIND.FILE && !!this.mediaReference;
  }
  

  /* ##############################################################################
            cycle de vie
  ############################################################################## */

  ngAfterViewInit() {
    setTimeout(() => {
      this.build(); // construction des champs
      this.feed(); // alimentation des champs (initiale)
 
        // écouteur de change sur les autres champs
        WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateValue);
        if (!!this.widget) { // pas de ref au pivot en mode templating, ni dans la vue Freedata
          // mise à jour depuis le parent
          WizEventManager.addListener(this, this.widget, ALK_EVENT_TYPE.FORM_REFRESH_FIELDS, this.synchronize);
          WizEventManager.addListener(this, this.widget, ALK_EVENT_TYPE.FORM_REFRESH_ERRORS, this.showErrors);
          // WizEventManager.addListener(this, this.widget, ALK_EVENT_TYPE.FORM_ZONE_APPLY, this.managerContainers);
        }
    }, 0);
  }

  ngOnDestroy(){
      WizEventManager.removeListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE);
      if (!!this.widget) { // pas de ref au pivot en mode templating  
        WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.UPDATE_FD_FIELD);
        WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.FORM_REFRESH_ERRORS);
        // WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.FORM_ZONE_APPLY);
      }
  }

  /**
   * activation des champs selon le type
   */
  private build(): void {

    this.argContainer.wizDisabled = false;
    if (!this.sourceFDV) {
      return;
    }    

    // interception du contenu libre (pas de args)
    if(!this.sourceArg) {  
      switch(this.context?.fdvf) {
        case ViewData.FORM_HTML:
          this.usefreeGrp = true; 
          setTimeout(() => {
            if(this.ae) {
              this.ae.config = this.editorConfig;
              this.ae.placeholder='';
              this.ae.showPlaceholder = false;

            } 
          }, 0);

        break;
        case ViewData.FORM_ACTION:        
          this.usebt = true; 
        break;
        case ViewData.FORM_IMAGE:
          this.usefreeImgGrp = true;
        break;
        case ViewData.FORM_DROP:
          this.useDropGrp = true;
        break;
        case ViewData.FORM_ZONE:
          this.usefreeZone = true;
        break;
      }
    } else { // un arg est dispo

      this.datakind = this.sourceArg.dataType; // pour les formules, le type final peut être différent
      
      if(this.sourceArg.code === WizConstants.FIELD_PARENT_CODE) { // gestion du parent depuis la liste... des parents
          
        // TODO TODO prendre le parent comme realFD
        this.datakind = FIELD_KIND.OBJECT;            
          // créer un FormFieldObj
          let ffo: FormFieldObj = new FormFieldObj(
              this.widget as unknown as IForm, 
              null, 
              this.context, 
              true);
            
            ffo.fkd = this.field.fkd;
            ffo.clone = this.data.fdv; // pour s'assure du label en mode conf
            ffo.arg = this.data.arg;

            this.ffoValue = ffo; // on va passer tout le formField au composant ddExt
            this.useddext = true;
            // console.log('parent', ffo);
      } else


      // pour les formules, on prend le type du format (s'il existe)
      if(this.sourceArg.dataType === FIELD_KIND.FORMULA) { 
        this.datakind = FIELD_KIND.STRING;
        try {
          let format = this.sourceArg.format;
          // console.log('formula format', format);
          let formatVO = this.model.formatEngine.getFormat(format.split(ViewData.KEY_SEPARATOR)[0], format.split(ViewData.KEY_SEPARATOR)[1]);
          this.datakind = formatVO.dataKind;
        } catch(e: any){}
      } else 

      // gestion des sous-champs
      if(this.sourceArg.dataType === FIELD_KIND.OBJECT) { 
        let realFD: FreeDataVO = null;
        let realFDCode: string;
        let useNonUniqueField: boolean = false;
        try {
          realFDCode = this.sourceArg.datas.split(ViewData.CONTEXT_SEPARATOR)[0];
          realFD = this.model.freedataEngine.getFreeData(realFDCode);
        } catch(e: any) {}
        
        if(realFD) {
          if(this.context?.subField) {
            this.subArg = this.model.freedataEngine.getArgFromFD(realFD.code, this.context.subField);
            let uniqueFields: string[] = [WizConstants.FIELD_CODE, WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL];
            if(!!this.context.subField && uniqueFields.indexOf(this.context.subField) === -1) {
              useNonUniqueField = true;
              this.datakind = this.subArg.dataType;
            } 
          } else { // vue freedata
            this.subArg = this.model.freedataEngine.getArgFromFD(realFD.code, WizConstants.FIELD_LABEL);
            // on reste en objet pour la vue FDV this.datakind = this.subArg.dataType;
          }
          
        } 

        // champ unique, drop pour sélection
        if(realFD && !useNonUniqueField && this.field) { // && this.field pas dispo dans la vue freedata
        
          this.datakind = FIELD_KIND.OBJECT;            
          // créer un FormFieldObj
          let ffo: FormFieldObj = new FormFieldObj(
              this.widget as unknown as IForm, 
              null, 
              this.context, 
              true);
            
            ffo.fkd = this.field.fkd;
            ffo.clone = this.data.fdv; // pour s'assure du label en mode conf
            ffo.arg = this.data.arg;

            this.ffoValue = ffo; // on va passer tout le formField au composant ddExt
            this.useddext = true;
        } else if(this.data.fdvView) {
          // console.log('object sur FDV');
          this.datakind = FIELD_KIND.OBJECT;            
          // créer un FormFieldObj
          let ffo: FormFieldObj = new FormFieldObj(
              null, 
              null, 
              getDefaultWidgetConfigurationItemObj(), 
              true);
            
            ffo.fkd = null;
            ffo.clone = this.data.fdv; // pour s'assure du label en mode conf
            ffo.arg = this.data.arg;
            ffo.model = this.model;

            this.ffoValue = ffo; // on va passer tout le formField au composant ddExt
            this.useddext = true;
        }
        
      }  
      
      // a partir de là, on passe en realArg, possible sous-FDV
      switch(this.datakind) {
        case FIELD_KIND.OBJECT: 
          // console.log('OBJECT');
          // TODO TODO sous-sous-objet
          break;
        case FIELD_KIND.WORKFLOW: 
          // console.log('WORKFLOW argrenderer');
          this.useworkflow = true;
          break;         
        case FIELD_KIND.BINARY: // image, en fait
          this.useimgGp = true;  
        break;
        case FIELD_KIND.BINARY_MULTI: // image, en fait
          this.useimgMultiGp = true;
          this.gatlingMode = !!this.widget?.context?.gatling;
          // console.log('gatling', this.widget?.context?.gatling);
        break;       
        case FIELD_KIND.COLOR: // une couleur
          this.usecolor = true;  
        break;
        case FIELD_KIND.FILE: // lien média
          this.useDropGrp = true;  
      break;
        case FIELD_KIND.NUMBER:
          if(!!this.realArg?.format) { // prise du nbr de décimales sur le format
            let format = this.realArg.format;
            let formatVO = this.model.formatEngine.getFormat(format.split(ViewData.KEY_SEPARATOR)[0], format.split(ViewData.KEY_SEPARATOR)[1]);
            if(formatVO && !formatVO.partsBuilded) {
              console.log('not builded', formatVO, formatVO.code);
            }
            this.decimal = formatVO?.precision; //  || 2;
          } else {
            this.decimal = 2; 
          }
          this.wizmin = this.realArg.minValue;
          this.wizmax = this.realArg.maxValue;
          this.useni = true;
        break;
        case FIELD_KIND.INT: 
          this.decimal = 0;
          this.wizmin = this.realArg.minValue;
          this.wizmax = this.realArg.maxValue;
          this.useni = true;
        break;
        case FIELD_KIND.DATE: 
          this.useda = true;
        break;
        case FIELD_KIND.BOOLEAN:
          this.usecb = true; 
        break;
        case FIELD_KIND.COMMENT:
          this.wizmax = this.realArg.maxValue || 255; 
          this.useta = true; 
        break;
        case FIELD_KIND.ACTION: 
          this.cnx = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(this.realArg.action);
          this.usebt = true; 
        break;
        case FIELD_KIND.LIST:
          // console.log('argRenderer use list', this.data);
          this.uselistGP = true;
        break;
        case FIELD_KIND.THRESHOLD:
          // console.log('argRenderer use list', this.data);
          this.usethresholdGP = true;
        break;
        case FIELD_KIND.STRING: 
        case FIELD_KIND.TRS_LABEL:
          let formatBypass: boolean = false; // rendu autre que le texte  

          if(!!this.context?.fmt) { // patch gestion media et hyperlink
            const twoPart: string = this.context?.fmt.split(ViewData.KEY_SEPARATOR)[1];
            if(twoPart === 'MEDIA') {
              formatBypass = true;
              this.usemedia = true;   
            } else if(twoPart === 'HYPER') {
              formatBypass = true;
              this.uselinkGp = true; 
            }
          } 

          if(!!this.realArg.regex) {
            this.forceRestrict = new RegExp('^'+ this.realArg.regex +'$');
          }

          if(!!this.realArg.upper) {
            this.forceCaps = 'upper-case-input';
          }

          this.wizmax = this.realArg.maxValue || 50;

          // fin patch gestion media et hyperlink
          if(!formatBypass) {
            if(this.realArg.code === WizConstants.FIELD_CODE || this.realArg.code === WizConstants.FIELD_SHORT_CODE) {
              this.forceCaps = 'upper-case-input';
              this.forceRestrict = ViewData.CODE_REGEXP;

            }
            this.useti= true; 
          }
        break;
        // default: 
        //   this.wizmax = this.arg.maxValue || 50;
        //   this.useti= true; 
        // break;
      }
    }
  }

  /**
   * alimentation initiale ou par injection de valeurs sur peuplement automatique
   * public car peut être appelé par le BlGridsterItem lors de la mise à jour de la configuration du champ
   */
  public feed(): void {
    if (!this.sourceFDV) {
      return;
    }

    this.checkEditAvailable(); // gestion des restrictions en édition

    // alimentation de la valeur de base
    let protoValue: string = null;
    if (!!this.sourceArg) {
      protoValue = this.sourceFDV.argsObjVO[this.sourceArg.code] || null;
    } else { // de l'html libre, une image ou une action Connect
      protoValue = this.context?.lbl;
    }  

    if(!protoValue && !this.rawValue) { // tout vide
      // console.log('all null', this.sourceArg?.code);
      this.feedValue(this.rawValue); // un tour de boucle
    } else {
      if(protoValue !== this.rawValue) {
        this.rawValue = protoValue;
        this.formatedValue = this.rawValue; // par défaut...
        this.feedValue(this.rawValue);
      }
    }
  }

  /** 
   * gestion des restrictions de saisie (fonction de restriction sur codifs) 
   * 
   */
  private checkEditAvailable(): void {

    // if(!this.argContainer?.visible) {
    //   console.log('invisible me', this.sourceArg.code);
    // }

    if(this.context?.ro) {
      this.wizdisabled = true;
    } else {
      this.wizdisabled = false;
    }

    if (!!this.sourceArg &&  !!this.widget) { // on prend les éléments du fdForm
      const restrictSet: Map<string, string> = this.widget.restrictSet;
      const lockSet: Map<string, string> = this.widget.lockSet;
      if (restrictSet && restrictSet.has(this.sourceArg.code)) {
          this.argContainer.wizDisabled = true;
          this.argContainer.visible = false;
          return;
      } else if (lockSet && lockSet.has(this.sourceArg.code)) {
          this.wizdisabled = true;
          this.argContainer.wizDisabled = true;
          this.argContainer.visible = true;
      } else {
        if (this.context?.subField) { // un sous-champ, pas éditable
          this.argContainer.wizDisabled = true;
        } else {
          this.argContainer.wizDisabled = !!this.data?.context?.readOnly;
          //this.argContainer.visible = true;
        }
        this.argContainer.visible = true;
      }

      // lock sur le code si l'objet existe
      if(this.sourceArg.code === WizConstants.FIELD_CODE && this.sourceFDV?.exist) {
        this.argContainer.wizDisabled = true;
        this.argContainer.visible = true;
      }

      // lock sur le shortCode si l'objet existe
      if(this.sourceArg.code === WizConstants.FIELD_SHORT_CODE && this.sourceFDV?.exist) {
        this.argContainer.wizDisabled = true;
        this.argContainer.visible = true;
      }

      // lock sur le parentCode si l'objet existe
      if(this.sourceArg.code === WizConstants.FIELD_PARENT_CODE && this.sourceFDV?.exist) {
        this.wizdisabled = true;
        this.argContainer.wizDisabled = true;
        this.argContainer.visible = true;
      }


      if (this.sourceArg?.dataType === FIELD_KIND.FORMULA) { // pas d'édition pour les formules
        this.argContainer.wizDisabled = true;
      }

    }
  }
  /** 
   * alimentation des champs
   * @param value la valeur source 
   */
  private feedValue(sourceValue: string): void {
    
    if(!this.realArg) { // interception du contenu libre 
      switch(this.context?.fdvf) {
        case ViewData.FORM_HTML:   
          // console.log('feed value ArgR', this.formatedValue, sourceValue);
          setTimeout(() => {
            this.ae?.writeValue(this.formatedValue);
            this.readyfreeGrp = true;
            this.cdref.markForCheck();   
          }, 0);
            
        break;
        case ViewData.FORM_ACTION:        
          this.cnx = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(sourceValue);
        break;
        case ViewData.FORM_IMAGE:
          if(!!sourceValue) { 
            this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(sourceValue, true);
            this.imgBlobid = sourceValue;
          } else {
            this.imgSrcObs = of(null);
            this.imgBlobid = null;
          }
        break;
        case ViewData.FORM_ZONE:   
          this.freezoneHidden = !!this.widget.hiddenGroups?.get(this.data.context?.source?.pgrp);
          //console.log('FORM_ZONE', this.data.context?.source?.pgrp, this.freezoneHidden);           
        break;
      }
    } else { // un champ de codif

      let realValue: string = sourceValue;
      // value, c'est la rawValue pour le FDV de base...
      if(this.subArg) {
        if(!!realValue && !this.subFDV) { // un subArg et pas encore de subFDV
            let fdCode: string = realValue.split(WizConstants.CONTEXT_SEPARATOR)[0];
            let fdvCode: string = realValue.split(WizConstants.CONTEXT_SEPARATOR)[1];
            let realFD: FreeDataVO = this.model.freedataEngine.getFreeData(fdCode);
            this.subFDV = realFD?.getFreeDataValue(fdvCode);
        }

        if(this.subFDV) {
          if(this.context?.subField) {
            realValue = this.realFDV.argsObjVO[this.context.subField];
          } else {
            realValue = this.realFDV.argsObjVO[WizConstants.FIELD_LABEL];
          }
        }
      }

      switch(this.datakind) {
        case FIELD_KIND.OBJECT: 
          if(this.field) { //neutralisation pour la vue FD
            let ffo: FormFieldObj = new FormFieldObj(
              this.widget as unknown as IForm, 
              null, 
              this.context, 
              true);
            
            ffo.fkd = this.field.fkd;
            ffo.clone = this.data.fdv;
            ffo.arg = this.data.arg;
            this.ffoValue = ffo; // on va passer tout le formField au composant ddExt
          }
          // console.log('feed Object', this.rawValue);
          break;
        case FIELD_KIND.WORKFLOW: 
          let settings: any = this.data.arg.settings;
          if(!!this.context?.pmdexParams) { // override par params
            settings = this.model.widgetEngine.pmdExParams(this.context);
          }
          let strRes: string = this.model.workflowEngine.formatWorkflow(settings, realValue);
          if(strRes) {
            let objRes: any = JSON.parse(strRes);
            if(!!objRes.image) {
              this.workImageBlob = objRes.image;
              this.workImage = AttachmentService.getInstance().downloadAttachmentForWidget(objRes.image, true);
            } else {
              this.workImage = of(null);
            }
            if(!!objRes.media) {
              this.workFile = objRes.media;
            } else {
              this.workFile = null;
            }
            this.workIcon = objRes.icon || null;
            this.workflowLabel = objRes.keys?.join(" ") || null;
          } else {
            this.workImage = of(null);
            this.workImageBlob = null;
            this.workFile = null;
            this.workIcon = null;
            this.workflowLabel = null;
          }

          break;          
        case FIELD_KIND.BINARY:
          if(!!realValue) {
            // if(sourceValue === "9a82e408c956cb67e0e7b0effb9e94fdd73019d03efa89b68821f01bf7f71eb2.png") {
            //   console.log("got you");
            // }
            this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(realValue, true);
            this.imgBlobid = realValue;
          } else {
            this.imgSrcObs = null;
          }
        break;
        case FIELD_KIND.BINARY_MULTI:
          if(!!realValue) {        
            let parts: string[] = realValue.split(WizConstants.KEY_SEPARATOR);
            let format: FormatVO = null;
            if(!!this.context?.fmt) {
              let formatSplit = this.context.fmt.split(ViewData.KEY_SEPARATOR);
              format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
              if(format.regExp === '1') {
                this.onlyOneOnMulti = true;
                if(parts.length > 1) {
                  parts = parts.slice(0, 1);
                }
              }
            }
            // console.log('BINARY_MULTI', format, this.onlyOneOnMulti, parts);
            this.blobList = [];// new Map();
            parts.forEach(s => {

              let thumb: boolean = true;
              if(this.imageRatio >= ViewData.THUMB_MAX_SIZE) {
                thumb = false;
              }
              // TODO selon la taille de la zone
              this.blobList.push({blobId:s, obs:AttachmentService.getInstance().downloadAttachmentForWidget(s, thumb)});
            });
            
          } else {
            if(this.readOnly) {
              this.blobList = null;
            } else {
              this.blobList = null;
            }    
          }
        break;
        case FIELD_KIND.COLOR:
          if(!realValue) {
            this.formatedValue = StyleEngine.STYLE_DEFAULT_WIDGET_BACKGROUND_COLOR;
          } else {
            this.formatedValue = realValue;
          }
        break;
        case FIELD_KIND.LIST:
          this.formatedValue = this.model.listFieldEngine.generateRendererForFDV(this.widget?.fakeFei, this.data.fdv, this.data.arg, this.rawValue, '<br>');
        break;
        case FIELD_KIND.THRESHOLD:
          this.formatedValue = this.model.listFieldEngine.generateThresholdRendererForFDV(this.widget?.fakeFei, this.data.fdv, this.data.arg, this.rawValue, '<br>');
        break;        
        case FIELD_KIND.FILE: // lien média
          // console.log('file arg', this.realArg, sourceValue);
          if(realValue) {
            try{
              this.mediaReference = JSON.parse(realValue);  
            }
            catch(e: any) {
              this.mediaReference = {fileName: 'err', fileType: 'err', blobId: 'err', shortFileName: 'err', v2: false, directory: null};
            }
          } else {
            this.mediaReference = null;
          }
        break;
        case FIELD_KIND.NUMBER:
        case FIELD_KIND.INT:         
          this.formatedValue = Number(realValue);
        break;
        case FIELD_KIND.DATE: 
          this.formatedValue = Number(realValue);
        break;
        case FIELD_KIND.BOOLEAN:
          this.formatedValue = realValue === '1'; //  = WizBooleanUtils.stringToBoolean(valueStr); 
        break;
        case FIELD_KIND.COMMENT: 
          
        break;
        case FIELD_KIND.ACTION: 

        break;
        case FIELD_KIND.STRING: 
          let formatBypass: boolean = false; // rendu autre que le texte  

          if(!!this.context?.fmt) { // patch gestion media et hyperlink
            const twoPart: string = this.context.fmt.split(ViewData.KEY_SEPARATOR)[1];
            if(twoPart === 'MEDIA') {
              formatBypass = true;
              this.formatedValue = realValue;
            } else if(twoPart === 'HYPER') {
              formatBypass = true;
              const dataStr: string = realValue; // la chaine de texte
              const dataParts: string[] = dataStr?.split(ViewData.KEY_SEPARATOR);
              if(!!dataParts) {
                this.linkUrl = dataParts[0];
                this.linkLabel = dataParts.length > 1 ? dataParts[1] : dataParts[0];
              }
            }
          } 
        break;
        default: 

        break;
      }
    }
  }

  /** mise à jour de l'arg */
  private updateValue(e:WizEvent): void {
    // console.log('updateValue', e.component, e.value);
    let valueStr: string = null;
    
    if(this.data.arg) {
      switch(e.component) {
        case this.ti:
          valueStr = e.value;
          if(this.data.arg.code === WizConstants.FIELD_CODE && !!valueStr) {
            valueStr = valueStr.toUpperCase();
          }   
          if(this.data.arg.code === WizConstants.FIELD_SHORT_CODE && !!valueStr) {
            valueStr = valueStr.toUpperCase();
          }   
          if(this.data.arg.upper && !!valueStr) {
            valueStr = valueStr.toUpperCase();
          }   
        break;
        case this.ta: 
          valueStr = e.value;
        break;
        case this.ni: 
          valueStr = e.value !== null ? e.value.toString() : null;
          // console.log('arg ni', e.value, valueStr);
        break;
        case this.da: 
          valueStr = WizDateUtils.dateToString(e.value) || null;
          // if(!valueStr) {
          //   this.formatedValue = null;
          // }
          //console.log('argRenderer date', e.value, valueStr);
        break;
        case this.cb: 
          // console.log('cb val', e.value);
          valueStr = e.value;
        break;
        case this.img: 
          valueStr = e.value;
          this.img.sourceObservable = AttachmentService.getInstance().downloadAttachmentForWidget(valueStr, false);
        break;
        case this.icoMulti:  
          this.refreshMulti(e.value);
          let parts: string[] = [];
          this.blobList?.forEach(couple => {
            parts.push(couple.blobId);
          });
          valueStr = parts.join(WizConstants.KEY_SEPARATOR);
          // valueStr = [...this.blobList.keys()].join(WizConstants.KEY_SEPARATOR);
        break;
        case this.icoAddFile: 
          if(e.value) {
            let med: Attachment = e.value[0];
            let blobId: string = e.value[1];
            this.mediaReference = {fileName: med.fileName, fileType: med.fileType, blobId: blobId, shortFileName: med.fileName.substring(0,50), v2: false, directory: null};
            valueStr = JSON.stringify(this.mediaReference);
          }
          // console.log('icoAddFile', valueStr);
        break;
        case this.icoDelFile: 
          // console.log('icoDelFile', e.component, e.value);
          // valueStr = e.value;
          this.mediaReference = null;
        break;
        case this.ddext: 
         if (!!e.value) {
            let ffo: FormFieldObj = e.value;
            let clone: FreedataValueVO = ffo.clone;
            valueStr = clone.argsObjVO[ffo.arg.code] || null;
          } else {
            valueStr = null;
          }
          // console.log('update Object', this.rawValue, valueStr);
          break;
        case this.icoList: 
          valueStr = e.value || null;
          // console.log('argRenderer update list', e.value, valueStr);
        break;  
      }
  
      // neutraliser les faux positifs sur la dropDown
      if(valueStr !== this.rawValue && !(!valueStr && !this.rawValue)) {
        WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: this.data, value: valueStr}));
      }
    } else { // drop de binaire
      // console.log('binary drop', e);
    }
    
  }

  /**
   * réception d'une mise à jour de champs par le formulaire
   * @param e 
   */
  private synchronize(e:AlkEvent): void {
    
    let updateFields: Set<string> = e.data;
    if(!updateFields) { // on est en cancel / reload, on refresh
      this.feed();
    } else if(updateFields.has(this.sourceArg?.code)) { // je suis concerné
      // console.log('synchronize', this.sourceArg?.code, updateFields, this.context.subField);
      // j'ai un delta sur le rendu... faut buter le subFDV et le remplacer
      if(this.sourceArg?.dataType === FIELD_KIND.OBJECT && this.realArg?.dataType !== FIELD_KIND.OBJECT) {
        // console.log('synchronize on object', this.sourceArg?.code, updateFields, this.context.subField);
        this.subFDV = null;
      }
      this.feed();
    }

    // dans tous les cas, on check les restrictions
    this.checkEditAvailable();
  }

  /* ##############################################################################
          contrôles de cohérence
  ############################################################################## */

  /** champs obligatoires */
  public get checkMandatory(): boolean {
    if (!!this.widget && !!this.data.arg) { // on prend les éléments du fdForm
      const requiredParts: Set<string> = this.widget.requiredFields;
      if (requiredParts && requiredParts.has(this.data.arg.code)) {
        return true;
      }
    }
    return false;
  }

  /** 
   * controle de cohérence de la value saisie 
   * (fonctions de contrôle sur codifs) 
   * appelé depuis les composants
   */
  public checkValueAvailable(): WizValidatorFn { 
    return (): WizValidationErrors | null => {
      
      if(this.sourceArg.code === WizConstants.FIELD_CODE || this.sourceArg.code === WizConstants.FIELD_SHORT_CODE) {
        if (this.ti?.wizValue?.length > 0) {
          // Recherche d'un autre fdv avec le même code
          let otherFdv: FreedataValueVO = null;
          if(!this.otherMap) {
            this.otherMap = new Map(this.widget.fdvDS.getSource().map(item => [item[this.sourceArg.code], item]));
          }
          otherFdv = this.otherMap?.get(this.ti.wizValue.toUpperCase());
          
          // Si une codif existe deja avec le meme code on affiche le message
          if (!!otherFdv && otherFdv.uid !== this.sourceFDV.uid) {
            const temp: WizValidationError = {
              wizError: '$.freedata.error.code.unique.$',
              wizErrorParams: [],
            };
            return [temp];
          } 
        }
        return null;
      };
         
      if (!this.data.arg?.validator) { // restriction d'affichage selon un autre champ
        return null;
      }
      const neoExp = this.data.arg.validator;
      let result: boolean = this.model.freedataFormulaCoreEngine.checkFreedataExp(this.data.fdv, neoExp, this.widget.fakeFei);
      //console.log('checkValueAvailable', result, this.data.fdv?.argsObjVO['DDSES'], this.data.fdv?.argsObjVO['DFSES']);
      if (!result) {
        // console.log('arg Error', this.data.arg.trsValueControlMessage);
        const temp: WizValidationError = {
          wizError: this.data.arg.trsValueControlMessage, // '$.common.error.$',
          wizErrorParams: [],
        };
        return [temp];
      }
      
      return null;
    }
  }

  /* ##############################################################################
        gestion des médias
  ############################################################################## */

  public get forceCam(): boolean {
    return !!WizRoot.isMobile() && !WizRoot.isIOS();
  }

  /** mode camera si mobile */
  public showCameraOrFolder(mode: string, multiple: boolean = false): void {
    
    if(!mode){
      return;
    }

    let params: ImageUploadParameter = {
            component: this.img,
            elementRef: this.img.elementRef,
            dom: this.model.domainCode,
            bu: this.model.businessUnitCode,
            vision: ViewData.wildcardMainVision,
            thumb: true,
            multiple
            // environment: true
          };

    if(mode === 'camera') {
      params.environment = true;
    }

    this.model.batchEngine.loadImage(params);
  }

  private hackTwice: boolean = false;

  /**
   * Demande de chargement d'une image
   * sur clic long, ouverture du zoom
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  /**
   * 
   * @param latency clic long / ou pas
   * @param blobid réf du média
   * @param noEdit // neutralisation de la caméra / prise de photos
   * @param mode mobile ou PC
   * @param multiple 
   * @returns 
   */
  public clickForUpload(latency: number, blobid: string, noEdit:boolean = false, mode: string, multiple: boolean = false): void {

    // console.log('clickForUpload', latency, obs, noEdit, mode); 
    if(!!this.rawValue && latency >= 400) {
      this.seeImage(blobid);
    } else {
      
      if(noEdit || this.onlyOneOnMulti) {
        // mode multi-images, on ne fait rien
      } else {
        if(this.readOnly) {
          return;
        }

        if(!this.hackTwice) {
          this.hackTwice = true;  
          if(mode === 'mobile' && WizRoot.isMobile() && this.forceCam) {
          this.showCameraOrFolder('camera', multiple);
          } else {
            this.showCameraOrFolder('folder', multiple);
          }
          setTimeout(() => {
            this.hackTwice = false; 
          }, 500);
        }
        



      }
    }
  }

  /**
   * demande d'ouverture sur l'image picker par clavier; touche entrée ou espace
   * @param event event clavier
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public keydownForUpload(event: KeyboardEvent): void {
    if(this.readOnly) {
      return;
    }
    
    const isEnterKey = event.key === VALUE_ENTER; // touche entrée
    const isSpaceKey = event.code === CODE_SPACE; // touche espace
    if (isEnterKey || isSpaceKey) {
      this.clickForUpload(0, this.imgBlobid, false, 'desktop');
    }
  }

  /**  de suppression des... icones */
  public clearImage(): void {

    WizPopUp.confirm(
      '$.common.delete.title.$',
      '$.common.delete.detail.$',
      this.doClearImage.bind(this),
      CONFIRMATION_MODE.CONFIRM_CANCEL,
      this,
      null,
      null
    ).show();
  }

  /**  de suppression des... icones */
  public doClearImage(confirmationResult: ConfirmationResultObj): void {
    if (confirmationResult.result === CONFIRMATION_RESULT.CONFIRM) {
      this.img.sourceObservable = of(null);
      WizEventManager.dispatchEvent(this.img.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.img, null));
    }
  }


  /* ##############################################################################
       gestion des actions connect
  ############################################################################## */

  /** fonction liée au bouton d'action */
  public doArgAction(): void {   
    
    let cnxCode: string = null;
    // interception fonctions IA
    let isIACall: boolean = false;
    
    if(!!this.data.arg) {
      cnxCode = this.data.arg.action;
      // interception fonctions IA
      if(this.data.arg.settings?.kind === 'IA') {
        isIACall = true;
      }

    } else { // connect libre
      cnxCode = this.field.contextItem.lbl;
    }


    if(!!cnxCode) {
      if(isIACall) {
        //console.log('do Act', this.data.arg, this.data.fdv);
        this.model.connectEngine.doAiAction(cnxCode, this.widget, this.data.arg, this.data.fdv, this.backFromAiAction.bind(this));
      } else {
        this.model.connectEngine.doArgActionExt(cnxCode, this.widget, [this.data.fdv]);
      }
      
    }
  }

  private backFromAiAction(target: ArgEditorData, value: string): void {
    // console.log('argRenderer backFromAiAction', target, value);
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: target, value}));
  }

  /**
   * neutralisation du dragOver, sinon le drop ne fonctionne pas...sous chrone
   */
  public dover(evt: DragEvent): void {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    // console.log('dover', evt);
  }

  /**
     * Demande de chargement d'un fichier
     */
  public selectFile(): void {

    let params: UploadParameter = {
      callback: null, // sera alimenté par le batchEngine
      accept: [WIZ_UPLOAD_ACCEPT_FORMAT.FILE_ANY],
      multiple: false, // false par défaut
      maxSize: 30, // 30 Mo
      noEncode: true,
      elementRef: this.dropGrp.elementRef,
      targetPath: this.data?.arg?.settings?.path || null,
      viewCallback: this.backFromSelect.bind(this)
    }
    this.model.batchEngine.loadFile(params);
  }

  /**
   * retour de sélection de fichier
   * @param params 
   */
  private backFromSelect(params: UploadParameter): void {
    if(params.files?.length > 0) {
      params.viewCallback = this.backFromDrop.bind(this);
      this.model.batchEngine.dropFile(params);
    }
  } 

  /**
   * Demande de chargement par drop
   */
  public dropFile(evt: DragEvent): void {
    
    evt.preventDefault();
    evt.stopImmediatePropagation();
    const files = evt.dataTransfer.files;
    let file: File = files[0];
  
    let params: UploadParameter = {
      callback: null, // sera alimenté par le batchEngine
      accept: [WIZ_UPLOAD_ACCEPT_FORMAT.FILE_ANY],
      multiple: false, // false par défaut
      maxSize: 30, // 30 Mo
      elementRef: this.dropGrp.elementRef,
      targetPath: this.data?.arg?.settings?.path || null,
      files: [file],
      noEncode: true,
      viewCallback: this.backFromDrop.bind(this),

    }
    
    this.model.batchEngine.dropFile(params);
  }

  /**
   * retour de chargement, enregistrement
   * @param media 
   * @param blobId 
   */
  private backFromDrop(media: Attachment, blobId: string): void {  
    WizEventManager.dispatchEvent(this.icoAddFile.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoAddFile, [media, blobId]));
  }

  /**
   * suppression de la pièce jointe
   */
  public clearDropFile(): void {
    WizEventManager.dispatchEvent(this.icoDelFile.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoDelFile, null));
  }

  /**
   * chargement de la pièce jointe
   */
  public loadDropFile(): void {
    AttachmentService.getInstance().filedownloadForWidget(this.mediaReference);
  }

  /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

  /**
   * affichage de la popUp du colorPicker
   * @param pEvent click
   */
  public showColorPicker(pEvent: Event): void {
    pEvent.stopPropagation();
    pEvent.preventDefault();
    ColorPickerPop.show(this.cellBlockBack.nativeElement, pEvent.target, this.formatedValue, this.backFromPicker.bind(this));
  }

  /**
   * retour de colorPicker, alimentation des couleurs du header
   *
   * @param target le span source pour font ou background
   * @param color la couleur du picker
   */
  public backFromPicker(target: any, color: string): void {
    
    let realColor: string = MathUtils.RGBA2HEX(color);
    // console.log('backFromPicker', color, realColor);
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: this.data, value: realColor}));
  }

  /** click sur les icones de suppression de style de header */
  public resetColor(who: string): void {
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: this.data, value: null}));
    // console.log('resetColor', who);
  }

  private zoomPop: WizPopUp; // la popUp de zoom sur les images

  /**
   * zoom sur une image
   */
  public seeImage(blobid: string): void {

      let blobSet: Set<string> = new Set();
      let blobList: string[] = [];   

      // extraction des blobId
      let argCode: string = this.data.arg.code;
      let rawVals: string[] = this.data.fdv.argsObjVO[argCode]?.split(WizConstants.KEY_SEPARATOR) || null;
      rawVals?.forEach(bid => {
        if(!blobSet.has(bid)) { // pas de doublons
          blobSet.add(bid);
          blobList.push(bid);
        }
      });


    let params: zoomPopParams = {
      zoomPop: this.zoomPop,
      blobid: blobid,
      blobList: blobList,
      callback: this.backFromOCR.bind(this)
    }
    
    PopUtils.showZoomPop(params);
  }

  private backFromOCR(result: any): void {
    
    if(result) { // on injecte dans un arg nommé OCR
      // console.log('result OCR', result);
      // prise du bon arg
      let arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(this.data.fdv.freeDataCode, 'OCR');
      if(!!arg) {
        let fakeAED: ArgEditorData = {arg, model: this.model, fdv: this.data.fdv};
        WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: fakeAED, value: result}));
      }
    }


    //console.log("arg backFromOCR", result);
  }


  public fastChange(compo: IWIZComponent, e: any): void {
    // console.log('fastChangeOnNumeric', compo, e);
    //console.log('fastChangeOnNumeric', compo, e);
    this.updateValue(new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, compo, e));
    setTimeout(() => {
      WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_KEY, {field: this.data}));
    }, 0);
    
  }

  /* ##############################################################################
       gestion des workflows
  ############################################################################## */

  public showWorkflow(e: any): void {
    // console.log('showWorkflow', e);

    let title = this.field?.arg?.trsLabel;
    let fkd: FeiKeyDef = new FeiKeyDef();
    fkd.datakind = FIELD_KIND.WORKFLOW;


    let datas: PivotCellEditPopData = { 
      kind: WIDGET_GLOBAL_KIND.FREEDATA,
      title, 
      label: null,
      value: this.rawValue, // realValue, //
      column: null,
      fkd, 
      line: null, 
      pack: null, 
      widget: this.widget, 
      fdv: this.data.fdv,
      arg: this.data.arg,
      pointer: e as PointerEvent,
      callback: this.backFromEditPop.bind(this)};

    /** ouverture de la pop d'édition en masse */
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SHOWPOP, datas));
  }

  /**
   * callBack de retour de la popUp d'édition en masse
   * @param data PivotCellEditPopData, avec UpdateRequest
   */
  public backFromEditPop(data: PivotCellEditPopData): void {
    // console.log('back from edit workflow', data);
    this.feedValue(data.updates?.value);
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: this.data, value: data.updates?.value}));
  }


  /* ##############################################################################
       gestion multi-images
  ############################################################################## */

  // @ViewChild('imgMultiGp', { read: WizGroup, static: true }) imgMultiGp: WizGroup; // image du FDV
    @ViewChild('imgMultiLbl', { read: WizLabel, static: false }) imgMultiLbl: WizLabel;
    @ViewChild('icoMulti', { read: WizIcon, static: false }) icoMulti: WizIcon;
    @ViewChild('icoSwap', { read: WizIcon, static: false }) icoSwap: WizIcon;
    @ViewChild('imgMultiContainer') imgMultiContainer!: WizHgroup; // image du FDV 


    useimgMultiGp = false;
    gatlingMode: boolean = false;

    // public imgMultiSrcObs: Observable<string>[] = [];
    public blobList: ThumbData[] = [];
    // accesseur en mode Map
    public get blobListMap(): Map<string, ThumbData> {
      let result: Map<string, ThumbData> = new Map();
      if(this.blobList?.length > 0) {
        result = new Map(this.blobList.map(item => [item.blobId, item]));
      }
      return result;
    }
    // public blobList: Map<string, Observable<string>> = new Map();
    // multi, afficher une seule pour rendu
    public onlyOneOnMulti: boolean = false;


    public get moreThanOne(): boolean {
      return this.blobList?.length > 1;
    }

    private _scrollbarSize = 15; // valeur moyenne Windows

    public get imageRatio(): number {
      // let res: number = this.elementRef.nativeElement.offsetHeight -30;
      let res: number = 50; //  -15 || 50;
      if(this.imgMultiContainer) {
        const el = this.imgMultiContainer.elementRef?.nativeElement;
        res = el.offsetHeight; //  -15;
        if(el.scrollWidth > el.clientWidth && !this.onlyOneOnMulti) {
          res = res - this._scrollbarSize;
          // console.log('imageRatio & scroll', this._goodRatio);
        }           } else {
        res = this.context?.rows*20;
      }    
      return res;
    }



    public addMultiImage(cam: boolean= false): void {
      
      let params: ImageUploadParameter = {
        component: this.icoMulti,
        elementRef: this.icoMulti.elementRef,
        dom: this.model.domainCode,
        bu: this.model.businessUnitCode,
        vision: ViewData.wildcardMainVision,
        multiple: true,
        thumb: true
        // environment: true
      };

      if(cam) {
        params.environment = true;
      }
      this.model.batchEngine.loadImage(params);
    }

    public refreshMulti(blobId: string): void {
      if(!this.blobList) {
        this.blobList = [];// new Map();
      }

      let thumb: boolean = true;
      if(this.imageRatio >= ViewData.THUMB_MAX_SIZE) {
        thumb = false;
      }

      if(this.blobListMap.has(blobId)) { // update
        let realInstance = this.blobListMap.get(blobId);
        realInstance[1] = AttachmentService.getInstance().downloadAttachmentForWidget(blobId, thumb);
      } else {
        this.blobList.push({blobId, obs:AttachmentService.getInstance().downloadAttachmentForWidget(blobId, thumb)});
      }
      // this.blobList.set(blobid, AttachmentService.getInstance().downloadAttachmentForWidget(blobid, true));
      this.cdref.markForCheck();
    }


  public clearImageMulti(blobid: string): void {
    // console.log('clearImageMulti', blobid);
    WizPopUp.confirm(
        '$.common.delete.title.$',
        '$.common.delete.detail.$',
        this.doClearImageMulti.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        blobid,
        null,
        null
      ).show();
    }

  /**  de suppression des... icones */
  public doClearImageMulti(confirmationResult: ConfirmationResultObj): void {
    if (confirmationResult.result === CONFIRMATION_RESULT.CONFIRM) {
      let realInstance = this.blobListMap.get(confirmationResult.data);
      this.blobList.splice(this.blobList.indexOf(realInstance), 1);
      // this.blobList.delete(confirmationResult.data);
      let parts: string[] = [];
      this.blobList?.forEach(couple => {
        parts.push(couple.blobId);
      });
      let valueStr = parts.join(WizConstants.KEY_SEPARATOR);
      WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: this.data, value: valueStr}));
    }
  }

  private showErrors(e: AlkEvent): void {
    this.validationContainer.check(true, true);
  }

  /* ##############################################################################
       swap multi-images
  ############################################################################## */



  private swapPop: WizPopUp; // la popUp de zoom sur les images
  /**
   * zoom sur une image
   */
  public swap(): void {
    
    if (PopUpManager.exist(this.swapPop)) {
      // suppression de l'instance existante
      this.swapPop.hide();
    }
    
    let popFactory: any = SwapPop;




    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.swapPop = new WizPopUp(
      popFactory,
      false,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      SwapPop.width,
      SwapPop.height
    );

    const pos: DOMRect = this.icoSwap.elementRef.nativeElement.getBoundingClientRect();
    const bestXY: [number, number] = PopUtils.setPopCoord(pos, this.swapPop, WIZ_PHYSIC_POSITION.BOTTOM_LEFT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    this.swapPop.customPosition = targetPosition;
    this.swapPop.callback = this.backFromSwap.bind(this);


    // alimentation des datas
    this.swapPop.datas = this.blobList;
    this.swapPop.show();
  }

  private backFromSwap(result: WizDatasource<ThumbData>): void {
    let parts: string[] = [];

    let newOrder: ThumbData[] = [];

    result.getSource().sort((a, b) => a.order - b.order).forEach(t => {
      let real: ThumbData = this.blobListMap.get(t.blobId);
      newOrder.push(real);
    });
    this.blobList = newOrder;

    this.blobList?.forEach(couple => {
      parts.push(couple.blobId);
    });
    let valueStr = parts.join(WizConstants.KEY_SEPARATOR);
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: this.data, value: valueStr}));
  }

  /* ##############################################################################
          gestion des  containers
     ############################################################################## */

    public showHideZone(): void {
      this.freezoneHidden = !this.freezoneHidden;
      // console.log('hideZone', this.freezoneHidden);
      WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_ZONE_UPDATE, {data: this.data, value: this.freezoneHidden}));
    }  

    // public sendMessage(e:string): void {
    //  WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.VERBOSE, e));
    // }

    // public async addToOCR(imageSrc: string): Promise<string> {
    //     // imageSrc peut être une URL, une DataURL (ex : 'data:image/...'), voire un File (à adapter)
    //     const worker = await createWorker('eng', 1, {
    //         logger: m => console.log(m) // Optionnel: logs de progrès
    //     });
    //     try {
    //         // Lance la reconnaissance
    //         const { data: { text } } = await worker.recognize(imageSrc);
    //         // Nettoie le worker après usage
    //         await worker.terminate();
    //         // Traite le texte OCR (affichage, insertion etc.)
    //         return text;
    //     } catch (error) {
    //         await worker.terminate();
    //         throw error;
    //     }
    // }


    // public recognizeOCR(blobID: string): void {
      
    //   AttachmentService.getInstance().downloadAttachmentForWidget(blobID, false).pipe(first()).subscribe({
    //     next: (imgSrc: string) => {
    //       const mime = WizFileUtils.detectImageMimeType(imgSrc);
    //       const dataUri = `data:${mime};base64,${imgSrc}`;
    //       // Appelle l'OCR (async)
    //       this.addToOCR(dataUri)
    //         .then(text => {
    //           console.log('Texte OCR:', text);
    //           // this.ocrResult = text;
    //         })
    //         .catch(err => {
    //           alert('Erreur OCR: ' + err);
    //         });
    //     },
    //     error: (err) => {
    //       alert("Erreur lors de la récupération de l'image à OCR : " + err);
    //     }
    //   });
    // }

  /* ##############################################################################
          gestion de la liste de valeurs
     ############################################################################## */

  /**
   * gestion des listes de valeur
   * @param pEvent click
   */
  public showListPop(e: any): void {
    let title = this.alternateLabel;

    const fakeMeas: MeasureVO = this.model.measureEngine.buildFake();
    fakeMeas.code = this.data.arg.code;
      fakeMeas.shortCode = this.data.arg.code;
      fakeMeas.mode = WizConstants.MEASURE_MODE_INTERACT; // interact, donc présentée par défaut
      fakeMeas.datakind = FIELD_KIND.LIST; // on veut une liste
      fakeMeas.settings = this.data.arg.settings;
    let fakeFkd: FeiKeyDef = BaselineEngine.buildFeiKeyDef(this.widget.fakeFei, KEY_KIND.MEASURE, fakeMeas.source, WizConstants.MEASURE_MODE_INTERACT);

    let datas: PivotCellEditPopData = { 
      kind: WIDGET_GLOBAL_KIND.FREEDATA,
      title, 
      label: null, 
      value: this.rawValue, // realValue, //
      column: null,
      fkd: fakeFkd, 
      line: null,//this.clone, 
      pack: null,//[this.clone], 
      widget: this.widget,
      arg: this.data.arg,
      fdv: this.data.fdv,
      pointer: e as PointerEvent,
      callback: this.backFromListPop.bind(this)};

    /** ouverture de la pop d'édition en masse */
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SHOWPOP, datas));
  }

  /**
   * callBack de retour de la popUp de saisie de liste
   * @param data PivotCellEditPopData, avec UpdateRequest
   */
  public backFromListPop(data: PivotCellEditPopData): void {
    // this.rawValue = data.updates?.value;
    //console.log('back frombackFromListPop', data, this.rawValue);
    WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoList, data.updates?.value));
    // this.feed(); // TODO à priori inutile
  }

  /* ##############################################################################
          gestion des seuils
     ############################################################################## */

  /**
   * gestion des seuils
   * @param pEvent click
   */
  public showThresholdPop(e: any): void {
    let title = this.alternateLabel;

    const fakeMeas: MeasureVO = this.model.measureEngine.buildFake();
    fakeMeas.code = this.data.arg.code;
      fakeMeas.shortCode = this.data.arg.code;
      fakeMeas.mode = WizConstants.MEASURE_MODE_INTERACT; // interact, donc présentée par défaut
      fakeMeas.datakind = FIELD_KIND.THRESHOLD; // on veut une liste
      fakeMeas.settings = this.data.arg.settings;
    let fakeFkd: FeiKeyDef = BaselineEngine.buildFeiKeyDef(this.widget.fakeFei, KEY_KIND.MEASURE, fakeMeas.source, WizConstants.MEASURE_MODE_INTERACT);

    let datas: PivotCellEditPopData = { 
      kind: WIDGET_GLOBAL_KIND.FREEDATA,
      title, 
      label: null, 
      value: this.rawValue, // realValue, //
      column: null,
      fkd: fakeFkd, 
      line: null,//this.clone, 
      pack: null,//[this.clone], 
      widget: this.widget,
      arg: this.data.arg,
      fdv: this.data.fdv,
      settings: this.data.arg.settings,
      pointer: e as PointerEvent,
      callback: this.backFromThresholdPop.bind(this)};

    /** ouverture de la pop d'édition en masse */
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SHOWPOP, datas));
  }

  /**
   * callBack de retour de la popUp de saisie de liste
   * @param data PivotCellEditPopData, avec UpdateRequest
   */
  public backFromThresholdPop(data: PivotCellEditPopData): void {
    // this.rawValue = data.updates?.value;
    // console.log('back frombackFromListPop', data.updates?.value);
    WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoThreshold, data.updates?.value));
    // this.feed(); // TODO à priori inutile
  }

  /**
   * chargement de la pièce jointe du workflow
   */
  public loadDropWorkFile(): void {
    AttachmentService.getInstance().filedownloadForWidget(this.workFile);
  }
}
